import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';

import VerifyUniqueLink from '../pages/uniqueLink/VerifyUniqueLink';
import InvalidUniqueLink from '../pages/financial/InvalidUniqueLink';

const { error: errorRoute } = RouteKey.child;

const { registration, invalid } = RouteKey['unique-link'].child;

const UniqueLinkRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/${registration}`}>
        <VerifyUniqueLink />
      </Route>

      <Route exact path={`${path}/${invalid}`}>
        <InvalidUniqueLink />
      </Route>

      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};
export default UniqueLinkRoute;
